module.exports = __webpack_public_path__ + "img/device.7e0f9e89.png";